class HCartFooter extends HTMLElement {
  // Componentes suscritos para validar la data
  components = {}
  constructor() {
    super()
    // Elementos del DOM para trabajar
    this.button = this.querySelector('button#update-cart[type="submit"]')
    this.clone = document.createElement('div')
    this.errors = this.querySelector('#cart-errors')
    this.form = document.querySelector('form[action^="/cart"]#cartform')

    // Secuestramos el botón
    this.clone.innerHTML = this.button.innerHTML
    this.clone.classList = this.button.classList
    this.button.insertAdjacentElement('afterend', this.clone)
    this.button.style.display = 'none'

    this.clone.addEventListener('click', e => {
      this.errors.textContent = ''
      const data = Object.fromEntries(new FormData(this.form))
      for (let name in this.components) {
        let validation = this.components[name].validate(data)
        if (!validation.valid) {
          this.printError(validation.error)
          return
        }
      }

      this.clone.style.display = 'none'
      this.button.style.display = 'inline-block'
      this.button.click()
    })
  }
  printError(error) {
    this.errors.textContent = "Debes aceptar rellenar los campos de facturación"
  }
  register(name, component) {
    this.components[name] = component
  }
}
if (!customElements.get('haciendola-cart-footer')) {
  customElements.define('haciendola-cart-footer', HCartFooter)
}